const selectorsHamburger  = {
    toggler: '.i4-site__navbar-toggler',
    burger:  '.burger_deluxe',
    navbar: '.i4-site__navbar-nav',
};

const initHamburger = function() {
    console.log('Init hamburger...');

    const toggler = document.querySelector(selectorsHamburger.toggler);
    const navbar = document.querySelector(selectorsHamburger.navbar);
    const burger = document.querySelector(selectorsHamburger.burger);

    if (toggler && navbar) {
        toggler.addEventListener('click', function (e) {
            e.preventDefault();

            if (navbar.classList.contains('toggled')) {
                toggler.classList.remove('toggled');
                burger.classList.remove('toggled');
                navbar.classList.remove('toggled');
            } else {
                toggler.classList.add('toggled');
                burger.classList.add('toggled');
                navbar.classList.add('toggled');
            }
        });
    }
};

window.addEventListener('DOMContentLoaded', initHamburger);
